import { useState, useEffect } from 'react'
import Select from 'react-select'
import classNames from 'classnames'
import { isDisabled } from '../../utils'
import { BEHAVIOR_TYPE, FIELD_TYPE, FIELD_ID } from '../../constants'
import { Alert } from 'reactstrap'
import { getSelectFieldChoices, calcMaxLength } from './AppObjectFieldUtils'
import PubSub from 'pubsub-js'
import { gql } from '@apollo/client'
import { makeInteger } from '../../utils'
import { FIELD_QUERY } from '../../graphql'
import AppObjectFieldYesNo from './AppObjectFieldYesNo'
import AppObjectFieldDate from './AppObjectFieldDate'
import AppObjectFieldText from './AppObjectFieldText'

const FIELD_Q = gql(FIELD_QUERY)

export default function AppObjectFieldFilterValue(props) {
  const { field, object, formInputs, parentObjectId, action, value, handleChange, hasChanged, multiHandleChange, multiHasChanged, inputAttribute } = props
  console.log('AppObjectFieldFilterValue rendered: ', props)

  const [choicesRetrieved, setChoicesRetrieved] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [controlFieldType, setControlFieldType] = useState()
  const [selectedField, setSelectedField] = useState()

  function localHandleChange(selectedValues) {
    setSelectedItems(selectedValues)
    multiHandleChange(selectedValues, hasChanged, field.id)
  }

  async function getSelectedField() {
    let theField = null
    if (formInputs[FIELD_ID.queryDetail.field].currentValue) {
      const { data, errors } = await window.apolloClient.query({ query: FIELD_Q, variables: { id: formInputs[FIELD_ID.queryDetail.field].currentValue.id } })
      if (data.field) {
        console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^', data.field)
        theField = data.field
        setSelectedField(data.field)
      }
      if (errors) {
        setGraphQLErrors(errors)
      }
      return theField
    }
  }

  function getControlType(selectedFieldType) {
    let controlFieldType = null
    switch (makeInteger(selectedFieldType)) {
      case FIELD_TYPE.shortText:
      case FIELD_TYPE.multilineText:
      case FIELD_TYPE.integer:
      case FIELD_TYPE.number:
      case FIELD_TYPE.currency:
      case FIELD_TYPE.objectId:
        controlFieldType = FIELD_TYPE.shortText
        break
      case FIELD_TYPE.objectType:
      case FIELD_TYPE.objectOwner:
      case FIELD_TYPE.objectState:
      case FIELD_TYPE.select:
      case FIELD_TYPE.multiSelect:
        controlFieldType = FIELD_TYPE.multiSelect
        break
      case FIELD_TYPE.date:
        controlFieldType = FIELD_TYPE.date
        break
      case FIELD_TYPE.yesNo:
        controlFieldType = FIELD_TYPE.yesNo
        break
      default:
    }
    return controlFieldType
  }

  async function handleDependsOnChangeEvent(msg, eventData) {
    console.log(`EVENT RECEIVED (AppObjectFieldFilterValue): ${field.name} recieved ${msg} to `, eventData)
    const selectedField = await getSelectedField()

    if (selectedField) {
      console.log(selectedField)
      const controlFieldType = getControlType(selectedField.type.id)
      switch (makeInteger(controlFieldType)) {
        case FIELD_TYPE.shortText:
          setControlFieldType(FIELD_TYPE.shortText)
          handleChange({ target: { id: field.id, value: '' } }, hasChanged)
          break
        case FIELD_TYPE.multiSelect:
          setControlFieldType(FIELD_TYPE.multiSelect)
          multiHandleChange([], multiHasChanged, field.id)
          setOptions([])
          setChoicesRetrieved(false)
          break
        case FIELD_TYPE.date:
          setControlFieldType(FIELD_TYPE.date)
          handleChange({ target: { id: field.id, value: '' } }, hasChanged)
          break
        case FIELD_TYPE.yesNo:
          setControlFieldType(FIELD_TYPE.yesNo)
          handleChange({ target: { id: field.id, value: 'Y' } }, hasChanged)
          break
        default:
          setControlFieldType(null)
      }
    }
  }

  // for fields that depend on other fields
  useEffect(() => {
    const tokens = []
    if (field.dependsOn) {
      for (let dependsOn of field.dependsOn) {
        tokens.push(PubSub.subscribe(`OBJECT: ${object.id} ${dependsOn.name} CHANGED`, handleDependsOnChangeEvent))
        return function cleanup() {
          for (let token of tokens) {
            PubSub.unsubscribe(token)
          }
        }
      }
    }
  })

  useEffect(() => {
    async function asyncFunction() {
      console.log('---------------------- AppObjectFieldFilterValue.useEffect[] first time setup...')
      const selectedField = await getSelectedField()
      const controlFieldType = getControlType(selectedField.type.id)
      console.log('=======================', selectedField, controlFieldType)
      setControlFieldType(controlFieldType)
    }
    asyncFunction()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let currentValue = []
  let initialOptions = []
  if (value && value.length > 0) {
    for (let item of value) {
      currentValue.push({ value: item.id, label: item.name })
    }
    if (!choicesRetrieved) {
      initialOptions = currentValue
    }
  }
  const [options, setOptions] = useState(initialOptions)
  const [selectedItems, setSelectedItems] = useState(currentValue)

  async function handleFocus() {
    console.log('AppObjectFieldFilterValue.hanldeFocus: ', selectedField)
    if (!choicesRetrieved) {
      const choiceValues = await getSelectFieldChoices(selectedField, object, parentObjectId, formInputs)
      setChoicesRetrieved(true)
      setOptions(choiceValues)
    }
  }

  if (isDisabled(action, field.behaviorType)) {
    let selecteItemsString = ''
    let comma = ''
    if (value && value.length > 0) {
      if (Array.isArray(value)) {
        for (let item of value) {
          selecteItemsString += `${comma} ${item.name}`
          comma = ', '
        }
      } else {
        selecteItemsString = value
      }
    }
    return (<span>{selecteItemsString}</span>)
  }

  const maxLength = calcMaxLength(options)
  const isClearable = (field.behaviorType.id === BEHAVIOR_TYPE.required) ? false : true

  let filterValueComponent = ''
  switch (controlFieldType) {
    case FIELD_TYPE.multiSelect:
      selectedField.behaviorType = { id: BEHAVIOR_TYPE.optional }
      console.log('`~~~~~~~~~~~~~~~~~~~~~~~~~~ AppObjectFieldFilterValue options: ', options)
      filterValueComponent =
        <Select
          valid={inputAttribute === 'valid'}
          invalid={inputAttribute === 'invalid'}
          name={field.id}
          className={classNames('app-object-field-select', { 'invalid': inputAttribute === 'invalid' }, { 'valid': inputAttribute === 'valid' })}
          id={field.id}
          value={selectedItems}
          onChange={(event) => localHandleChange(event)}
          onFocus={handleFocus}
          isClearable={isClearable}
          options={options}
          closeMenuOnSelect={false}
          isMulti
        />
      break
    case FIELD_TYPE.date:
      filterValueComponent =
        <AppObjectFieldDate
          field={field}
          action={action}
          value={value}
          handleChange={handleChange}
          hasChanged={hasChanged}
        />
      break
    case FIELD_TYPE.yesNo:
      filterValueComponent =
        <AppObjectFieldYesNo
          field={field}
          action={action}
          value={value}
          handleChange={handleChange}
          hasChanged={hasChanged}
        />
      break
    default:
      field.width = 25
      filterValueComponent =
        <AppObjectFieldText
          field={field}
          action={action}
          value={value}
          handleChange={handleChange}
          hasChanged={hasChanged}
          inputAttribute={inputAttribute}
        />
  }
  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else {
    return (
      <div style={{ minWidth: `${(5 * maxLength) + 150}px` }} data-cy={`field-${field.id}`}>
        {filterValueComponent}
      </div>
    )
  }
}
